 function setCimEnv(i) {
    window['om'] = {
        azde: {
            CimSessionHelper: {
                getUserInfo: () => {
                    return new Promise(
                        function (resolve, reject) {
                            resolve(
                                {"lastname": "Meine", "firstname": "Thomas", "azn": "1362660918"}
                            )
                        }
                    )
                },
                getTokenOrRedirectToLogin: () => {
                    return new Promise(
                        function (resolve, reject) {
                            resolve('1234646798798797987987979')
                        }
                    )
                },
                getToken: () => {
                    return new Promise(
                        function (resolve, reject) {
                            resolve('1234646798798797987987979-' + i++)
                        }
                    )
                }
            }
        }
    }
}

function setCimEnvNoAuth(i) {
    window['om'] = {
        azde: {
            CimSessionHelper: {
                getUserInfo: () => {
                    return new Promise(
                        function (resolve, reject) {
                            resolve(
                                {"lastname": "Meine", "firstname": "Thomas", "azn": "1362660918"}
                            )
                        }
                    )
                },
                getTokenOrRedirectToLogin: () => {
                    return new Promise(
                        function (resolve, reject) {
                            resolve('1234646798798797987987979')
                        }
                    )
                },
                getToken: () => {
                    return new Promise(
                        function (resolve, reject) {
                            reject(null)
                        }
                    )
                }
            }
        }
    }
}

function setCimEnvNoAuthError(i) {
    window['om'] = {
        azde: {
            CimSessionHelper: {
                getUserInfo: () => {
                    return new Promise(
                        function (resolve, reject) {
                            resolve(
                                {"lastname": "Meine", "firstname": "Thomas", "azn": "1362660918"}
                            )
                        }
                    )
                },
                getTokenOrRedirectToLogin: () => {
                    return new Promise(
                        function (resolve, reject) {
                            resolve('1234646798798797987987979')
                        }
                    )
                },
                getToken: () => {
                    return new Promise(
                        function (resolve, reject) {
                            reject(new Error('CIM BACKEND ERROR'))
                        }
                    )
                }
            }
        }
    }
}

(function () {
        const hrefValue = window.location.href;
        let i = 0;
        if (hrefValue.indexOf('?') !== -1) {
            const urlParams = window.location.href.split('?');
            const isLocalhost = hrefValue.indexOf('localhost') !== -1;
            const hasCim = urlParams[1].indexOf('cim=1') !== -1 && (isLocalhost);
            const hasCimError = urlParams[1].indexOf('cim=e') !== -1 && (isLocalhost);
            const hasCimErrorNull = urlParams[1].indexOf('cim=n') !== -1 && (isLocalhost);
            const hasCimNoAuth = urlParams[1].indexOf('cim=0') !== -1 && (isLocalhost);
            if (hasCimNoAuth) {
                setTimeout(setCimEnvNoAuth(i), 1000);
            }
            if (hasCim) {
                setTimeout(setCimEnv(i), 1000);
            }
            if (hasCimError) {
                setTimeout(setCimEnvNoAuthError(i), 1000);
            }

            console.log('hasCimErrorNull', hasCimErrorNull);
            if (hasCimErrorNull) {
                // setTimeout(setCimEnvNoAuthError(i), 1000);
            }
        }
    }
)()
